export default {
    statusPill: {
        draft: 'DRAFT',
        validated: 'VALIDATED',
        approved: 'APPROVED',
        locked: 'LOCKED 🔒',
        cancelled: 'CANCELLED',
    },
}
